export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.429 4.385a.75.75 0 01.186 1.044l-9.058 13a.75.75 0 01-1.16.088l-4.94-5.2a.75.75 0 011.087-1.034l4.308 4.534L18.385 4.57a.75.75 0 011.044-.186z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};